module.exports = __webpack_public_path__ + "static/media/cloud-icon.28cf6295.svg";